import React from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';

const ESTADOS_CIVIS = [
  { value: '', label: '(não informado)' },
  { value: 'solteiro', label: 'Solteiro(a)' },
  { value: 'casado', label: 'Casado(a)' },
  { value: 'divorciado', label: 'Divorciado(a)' },
  { value: 'viuvo', label: 'Viúvo(a)' },
  { value: 'uniao_estavel', label: 'União Estável' }
];

export default function DadosPessoaisTab({ form, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Identificação">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 6 }}>
          <Input label="Nome Completo" value={form.nome || ''} onChange={e => onChange('nome', e.target.value)} required autoFocus />
          <Input label="CPF" value={form.cpf || ''} onChange={e => onChange('cpf', e.target.value)} />
          <Input label="RG" value={form.rg || ''} onChange={e => onChange('rg', e.target.value)} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, marginTop: 8 }}>
          <Input label="Data de Nascimento" type="date" value={form.data_nascimento ? form.data_nascimento.slice(0, 10) : ''} onChange={e => onChange('data_nascimento', e.target.value)} />
          <Select label="Estado Civil" options={ESTADOS_CIVIS} value={form.estado_civil || ''} onChange={e => onChange('estado_civil', e.target.value)} />
          <Input label="Telefone" value={form.telefone || ''} onChange={e => onChange('telefone', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Contato e Endereço">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
          <Input label="Email" type="email" value={form.email || ''} onChange={e => onChange('email', e.target.value)} />
          <Input label="Cidade" value={form.cidade || ''} onChange={e => onChange('cidade', e.target.value)} />
        </div>
        <Input label="Endereço" value={form.endereco || ''} onChange={e => onChange('endereco', e.target.value)} style={{ marginTop: 8 }} />
      </Secao>

      <Secao titulo="Filiação">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
          <Input label="Nome do Pai" value={form.nome_pai || ''} onChange={e => onChange('nome_pai', e.target.value)} />
          <Input label="Nome da Mãe" value={form.nome_mae || ''} onChange={e => onChange('nome_mae', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Observações">
        <textarea value={form.observacoes || ''} onChange={e => onChange('observacoes', e.target.value)}
          rows={3} style={{ width: '100%', border: '1.5px solid #E4EAF0', borderRadius: 7, padding: '8px 9px', fontSize: 13, fontFamily: 'inherit', resize: 'vertical' }} />
      </Secao>
    </div>
  );
}
